import { useQuery } from '@tanstack/react-query';
import type { Dashboard, DashboardFinancieroResponse } from '@condo/contracts';
import { ApiRoutes } from '@condo/contracts';
import { api } from '@/lib/api/client';
import { queryKeys } from '@/lib/api/query-keys';

export function useDashboard(condoId: string) {
  return useQuery({
    queryKey: queryKeys.dashboard(condoId),
    queryFn: () => api.get<Dashboard>(ApiRoutes.dashboard(condoId)),
    enabled: !!condoId,
  });
}

export function useDashboardFinanciero(condoId: string) {
  return useQuery({
    queryKey: queryKeys.dashboardFinanciero(condoId),
    queryFn: () =>
      api.get<DashboardFinancieroResponse>(
        ApiRoutes.dashboardFinanciero(condoId),
      ),
    enabled: !!condoId,
  });
}
